import { Box, Card, CardContent, Typography } from "@mui/material";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

// Registra le scale e i componenti necessari
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const SensorThChart = ({ sensorId, data }) => {
    if (!data || data.length === 0) {
        return <Typography>Caricamento dati...</Typography>;
    }

    // Prepara i dati per il grafico
    const labels = data.map((entry) => new Date(entry.timestamp).toLocaleTimeString());
    const temperatureData = data.map((entry) => entry.temperature);
    const humidityData = data.map((entry) => entry.humidity);

    const chartData = {
        labels,
        datasets: [
            {
                label: "Temperatura (°C)",
                data: temperatureData,
                borderColor: "rgba(255, 99, 132, 1)",
                backgroundColor: "rgba(255, 99, 132, 0.2)",
                fill: true,
            },
            {
                label: "Umidità (%)",
                data: humidityData,
                borderColor: "rgba(54, 162, 235, 1)",
                backgroundColor: "rgba(54, 162, 235, 0.2)",
                fill: true,
            },
        ],
    };

    return (
        <Box sx={{ p: 3 }}>
            <Card>
                <CardContent>
                    <Typography variant="h5" gutterBottom>
                        Dati giornalieri del sensore {sensorId}
                    </Typography>
                    <Line
                        data={chartData}
                        options={{
                            responsive: true,
                            plugins: {
                                legend: { display: true },
                            },
                            scales: {
                                x: { title: { display: true, text: "Orario" } },
                                y: { title: { display: true, text: "Valore" } },
                            },
                        }}
                    />
                </CardContent>
            </Card>
        </Box>
    );
};

export default SensorThChart;